import { SaleModule } from './types/AnalysisModels';
import { Module } from './types/ChatbotModels';

export const normalizeAnalysisModuleName = (module: Module) => {
    switch (module) {

    case Module.ANALYSIS_SALE_HOUSE:
        return SaleModule.SALE_HOUSE;
    case Module.ANALYSIS_SALE_PLOT:
        return SaleModule.SALE_PLOT;
    case Module.ANALYSIS_SALE_OTHER:
        return SaleModule.SALE_OTHER;
    case Module.ANALYSIS_SALE_FLAT:
    default:
        return SaleModule.SALE_FLAT;
    }
};
